import React from 'react';
import { Button } from '@thd-olt-component-react/core-ui';
import { EXP_ROUTES } from '../../../../utils/constants';

const TemplatesLink = () => {

  const navToJobTemplates = () => {
    window.open(EXP_ROUTES.JOB_TEMPLATES, '_blank');
  };

  return (
    <div className="create-job-posting__tooltip-section" data-testid="pro-tip-templates-link">
      <div className="create-job-posting__tip-label">
        <p> Not sure where to start? </p>
      </div>
      <p>Browse job descriptions in our job template database.</p>
      <Button
        onClick={navToJobTemplates}
        data-testid="pro-tip-templates-link-button"
        className="create-job-posting__view-templates"
        outline
      >
        View All Templates
      </Button>
      <p style={{ fontWeight: '400', fontStyle: 'italic', marginTop: '15px' }}>Link opens templates in new tab</p>
    </div>
  );
};

export default TemplatesLink;